export default angular
  .module('st.Integrations.GoogleContacts', [])
  .service('googleContactsService', ($http, dataService, GOOGLE_CONTACTS) => ({
    authenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        GOOGLE_CONTACTS.API.AUTHENTICATE,
        {
          params
        }
      ),
    authenticated: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        GOOGLE_CONTACTS.API.AUTHENTICATED,
        {
          params
        }
      ),
    deauthenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        GOOGLE_CONTACTS.API.DE_AUTHENTICATE,
        {
          params
        }
      ),
    sync: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        GOOGLE_CONTACTS.API.SYNC,
        params
      )
  }))
  .constant('GOOGLE_CONTACTS', {
    API: {
      SYNC: '/api/v1/integration/googleContacts/sync',
      AUTHENTICATE: '/api/v1/integration/googleContacts/authenticate',
      AUTHENTICATED: '/api/v1/integration/googleContacts/authenticated',
      DE_AUTHENTICATE: '/api/v1/integration/googleContacts/deauthenticate'
    }
  });
